import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type OrderToppingModel = {
  id: string
  quantity: number
}

export type OrderDishModel = {
  id: string
  dishId: string
  sizeId?: string
  guestNumber: number
  extraNote?: string
  toppings?: OrderToppingModel[]
}

type OrderPayloadModel = {
  tableIds: string[]
  dishes: OrderDishModel[]
}

type OrderPageStore = {
  order: OrderPayloadModel
  setOrder: (order: OrderPayloadModel) => void
  addDish: (dish: OrderDishModel) => void
  setTableIds: (tableIds: string[]) => void
  removeDish: (dishId: string) => void
  removeDishes: (ids: string[]) => void
  resetOrder: () => void
}

const useOrderPageStore = create<OrderPageStore>()(
  persist(
    set => ({
      order: { tableIds: [], dishes: [] },
      setOrder: order => set({ order }),
      addDish: dish =>
        set(state => ({
          order: {
            ...state.order,
            dishes: [...state.order.dishes, dish]
          }
        })),
      removeDish: dishId =>
        set(state => {
          const idx = state.order.dishes.findIndex(dish => dish.id === dishId)
          if (idx === -1) return state
          return {
            order: {
              ...state.order,
              dishes: [
                ...state.order.dishes.slice(0, idx),
                ...state.order.dishes.slice(idx + 1)
              ]
            }
          }
        }),
      removeDishes: ids =>
        set(state => {
          const idSet = new Set(ids)
          return {
            order: {
              ...state.order,
              dishes: state.order.dishes.filter(dish => !idSet.has(dish.id))
            }
          }
        }),
      resetOrder: () => set({ order: { tableIds: [], dishes: [] } }),
      setTableIds: tableIds =>
        set(state => ({
          order: {
            ...state.order,
            tableIds
          }
        }))
    }),
    {
      name: 'order-page-store'
    }
  )
)

export default useOrderPageStore
